






























































import { mixins } from "vue-class-component";
import WeMixin from "@/components/weMixin";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import {
  Form,
  Calendar,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  List,
  Button,
  Cell,
  Picker,
  CellGroup,
  SwipeCell,
  ActionSheet,
  Dialog,
  Popup,
  DatetimePicker,
  Image,
  Collapse,
  CollapseItem,
  Divider,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import { Toast, Panel } from "vant";
import { Icon } from "vant";
import { Loading } from "vant";
import { PullRefresh, Grid, GridItem, Card, Tabbar, TabbarItem } from "vant";
import { NavBar } from "vant";
import Axios, { AxiosResponse } from "axios";
import { MerchantWh } from "./MerchantApi";

@Component({
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [List.name]: List,
    [Panel.name]: Panel,
    [Calendar.name]: Calendar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
    [Dialog.name]: Loading,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [SwipeCell.name]: SwipeCell,
    [ActionSheet.name]: ActionSheet,
    [Image.name]: Image,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [NavBar.name]: NavBar,
  },
})
export default class MerchantList extends mixins(WeMixin, Jssdk) {
  private infoList = [];
  private loadNumUp = 5;
  private loading: boolean = false;
  private finished: boolean = false;
  private pageNum = 0;

  private latitude: string = "";
  private longitude: string = "";

  private merchantWh: MerchantWh = {} as MerchantWh;

  protected created() {
    this.initWx().then((wjs: WxJsapiSignature) => {
      this.$wx.config({
        // debug: wjs.debug, // wjs.debug,
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wjs.appId, // 必填，公众号的唯一标识
        timestamp: wjs.timestamp, // 必填，生成签名的时间戳
        nonceStr: wjs.nonceStr, // 必填，生成签名的随机串
        signature: wjs.signature, // 必填，签名
        jsApiList: ["getLocation"], // 必填，需要使用的JS接口列表
      });
    });
  }

  protected loadList() {
    setTimeout(() => {
      this.$wx.getLocation({
        type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res: any) => {
          this.latitude = res.latitude;
          this.longitude = res.longitude;
          const page = {
            ep: this.loadNumUp,
            sp: ++this.pageNum,
            lat: this.latitude,
            lng: this.longitude,
          };
          api
            .post("/weixinmp/xsyx/merchant/getNearbyMerchantList", page)
            .then((response: AxiosResponse) => {
              const ss = response.data;
              console.log(ss);
              if (ss.length != 0) {
                this.infoList = this.infoList.concat(ss);
              }
              if (ss.length == 0) {
                this.finished = true;
              }
              this.loading = false;
            });
        },
        fail: (err: any) => {
          this.$toast("获取地址失败：" + JSON.stringify(err));
        },
      });
      // this.latitude = "32"; // 纬度，浮点数，范围为90 ~ -90
      // this.longitude = "118"; // 经度，浮点数，范围为180 ~ -180。
      // const page = {
      //   ep: this.loadNumUp,
      //   sp: ++this.pageNum,
      //   lat: this.latitude,
      //   lng: this.longitude,
      // };
      // api
      //   .post("/weixinmp/xsyx/merchant/getNearbyMerchantList", page)
      //   .then((response: AxiosResponse) => {
      //     const ss = response.data;
      //     console.log(ss);
      //     if (ss.length != 0) {
      //       this.infoList = this.infoList.concat(ss);
      //     }
      //     if (ss.length == 0) {
      //       this.finished = true;
      //     }
      //     this.loading = false;
      //   });
    }, 1000);
  }

  protected bindHeadImg(url: any) {
    return process.env.VUE_APP_MERCHANTPHOTO_PREURL + url;
  }

  protected toMerchantDetail(id: any) {
    this.$router.replace("/main/ydsq/merchantDetail/" + id);
  }
}
